module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/isabela-moscari-0e9a4ea5b33f4d26492c9df1dd5ea2bb.jpg";